import { useNormalizedData } from '@nivo/pie'
import { groupMapperLateral, pieColors } from '../dashHelper'
import { widgetsLibrary } from '../widgetsLibrary/widgetsLibrary'
import { lineDetailedMonthAndGeoMapper } from '../widgetsLibrary/widgetsLine'
import { DEFAULT_COLORS_WIDGETS } from '@components/widgets/apacheEchart/Commons'

export const OXXO_DEFAULT_COLORS = {
  ROJO_OSCURO: '#d9403d',
  ROJO: '#FD625E',
  VERDE: '#218C55',
  AMARILLO: '#F5D33F',
  AZUL: '#0E1A77',
  VERDE_OSCURO: '#0f4026'
}

export const OXXO_COLORS_STACKED_BAR = {
  1: OXXO_DEFAULT_COLORS.ROJO_OSCURO,
  2: OXXO_DEFAULT_COLORS.ROJO,
  3: OXXO_DEFAULT_COLORS.AMARILLO,
  4: OXXO_DEFAULT_COLORS.AZUL,
  5: OXXO_DEFAULT_COLORS.VERDE,
}

export const OXXO_COLORS_CONFIG_BAR = [
  // Negativo
  {
    color: OXXO_DEFAULT_COLORS.ROJO,
    condition: '<=' as const,
    key: 'value',
    value: 90,
  },
  // Neutro
  {
    color: OXXO_DEFAULT_COLORS.AZUL,
    condition: '>' as const,
    key: 'value',
    value: 90,
  },
  // Positivo
  {
    color: OXXO_DEFAULT_COLORS.VERDE,
    condition: '>' as const,
    key: 'value',
    value: 90,
  },
]


export const OXXO_DEFAULT_SCALE_3_COLORS = {
  'promoters': OXXO_DEFAULT_COLORS.VERDE,
  'passives': OXXO_DEFAULT_COLORS.AZUL,
  'detractors': OXXO_DEFAULT_COLORS.ROJO,
  'positive': OXXO_DEFAULT_COLORS.VERDE,
  'neutral': OXXO_DEFAULT_COLORS.AZUL,
  'negative': OXXO_DEFAULT_COLORS.ROJO,
}

export const commonWidgets: CommonWidget = {
  ...widgetsLibrary,
  diagramaIshikawa: {
    ...widgetsLibrary.diagramaIshikawa,
    //@ts-ignore
    config: {
      ...widgetsLibrary.diagramaIshikawa.config,
      mapper: (data, extra) => {
        return data
          // @ts-ignore
          ?.asMutable()
          .sort((item1: any, item2: any) => item2.count - item1.count)
      },
    }
  },
  mapByGeos: {
    ...widgetsLibrary.mapByGeos,
    //@ts-ignore
    config: {
      ...widgetsLibrary.mapByGeos.config,
      smallCircle: 10,
      mediumCirlce: 10,
      largeCircle: 10,
    }
  },
  // TODO: BORRAR DESPUES DE VERIFICAR QUE FUNCIONA EL EXTRAS
  atencionAgil: {
    title: '¿Cuál (es) fue el momento en el que lo atendimos ágilmente?',
    // [Column, Row]
    position: [1, 48],
    size: [2, 2],
    config: {
      id: 'SI_SERVICE_AGILE_OPTIONS',
      type: 'pie',
      fillMode: '',
      colors: pieColors,
      showValues: true,
      showSample: true,
      mapper: groupMapperLateral,
      itemWidth: 80,
      itemHeight: 20,
      //valueFormat: ' >-.1%',
      arcLabelsRadiusOffset: 1.15,
      itemDirection: 'left-to-right',
      anchor: 'top-left',
      direction: 'column',
      marginLeft: 250,
      legendTranslateX: -200,
      decimals: 2,
      indicators: [
        {
          indicator: 'SERVICE_AGILE_OPTIONS',
          //grouped: 'geoLocation',
          keyExtract: ['group', 'count', 'value'],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            responseValues: { 1305: ['SI'] }
          },
        },
      ],
    },
  },
  // TODO: BORRAR DESPUES DE VERIFICAR QUE FUNCIONA EL EXTRAS
  atencionNoAgil: {
    title: '¿Cuál (es) fue el momento en el que no lo atendimos ágilmente?',
    // [Column, Row]
    position: [0, 50],
    size: [2, 2],
    config: {
      id: 'NO_SERVICE_AGILE_OPTIONS',
      type: 'pie',
      fillMode: '',
      colors: pieColors,
      showValues: true,
      showSample: true,
      mapper: groupMapperLateral,
      itemWidth: 80,
      itemHeight: 20,
      //valueFormat: ' >-.1%',
      arcLabelsRadiusOffset: 1.15,
      itemDirection: 'left-to-right',
      anchor: 'top-left',
      direction: 'column',
      marginLeft: 250,
      decimals: 2,
      legendTranslateX: -200,
      center: ['30%', '50%'],
      indicators: [
        {
          indicator: 'SERVICE_AGILE_OPTIONS',
          //grouped: 'geoLocation',
          keyExtract: ['group', 'count', 'value'],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            responseValues: { 1305: ['NO'] },
          },
        },
      ],
    },
  },
  // TODO: este falta revisarlo!!!!!!
  generalSatisfactionDiesel: {
    title: 'Satisfacción general Diésel',
    // [Column, Row]
    position: [0, 2],
    size: [1, 2],
    config: {
      id: 'satisfaction-diesel',
      type: 'pie',
      colors: pieColors,
      radius: [40, 85],
      center: ['40%', '55%'],
      showHistoric: false,
      showSample: false,
      decimals: 2,
      mapper: (data: any) => {
        return [
          {
            id: 0,
            value: data[0].value,
            label: 'satisfecho',
            group: 'satisfecho',
          },
          {
            id: 1,
            value: 100 - data[0].value,
            label: 'insatisfecho',
            group: 'insatisfecho',
          },
        ]
      },
      indicators: [
        {
          indicator: 'satisfaction',
          keyExtract: ['group', 'count', 'value'],
          label: 'group',
          value: 'value',
          singleton: true,
        },
      ],
    },
  },
}

